
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 9.76005L5.02878 6.68488C4.79354 6.43837 4.41168 6.43837 4.17644 6.68488C3.94119 6.93139 3.94119 7.33153 4.17644 7.57804L7.59826 11.1254C7.82044 11.3582 8.18013 11.3582 8.40174 11.1254L11.8236 7.57804C12.0588 7.33153 12.0588 6.93139 11.8236 6.68488C11.5883 6.43837 11.2065 6.43837 10.9712 6.68488L8 9.76005Z","fill":"black"}})])
          )
        }
      }
    